import * as types from './actionTypes';

export const fetchKeysResponsibilities = (unit_id) => ({
  type: types.FETCH_KEYS_RESPONSIBILITIES,
  payload:{unit_id}
});

export const saveKeysResponsibilities = (payload) => ({
  type: types.SAVE_KEYS_RESPONSIBILITIES,
  payload,
});

export const changeKeysResponsibilitiesStatus = (payload) => ({
  type: types.CHANGE_KEYS_RESPONSIBILITIES_STATUS,
  payload,
});
